import { Dispatch } from 'redux';
import { ActionTypes, ReduxAction } from './types';
import store from '../store';
import { ConfigEnum, ConfigModel } from '../../models/ConfigModel';
import { setNotification } from '../../utils/notificationUtils';
import { ClientconfigService, ConfigParam } from '../../api';
import { booleanToString } from '../../utils/objectUtils';

export const updateConfigParam =
  (cpa: ConfigParam[]) => async (dispatch: Dispatch<ReduxAction>) => {
    new ClientconfigService().setClientConfig(cpa).then(response => {
      dispatch({
        type: ActionTypes.SET_CLIENT_CONFIG,
        payload: response.data,
      });
    });
  };

export const setConfigModel =
  (model: ConfigModel) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_CLIENT_CONFIG_MODEL,
      payload: model,
    });
  };

export const saveConfig = () => async (dispatch: Dispatch<ReduxAction>) => {
  const config: ConfigModel = store.getState().Config;

  new ClientconfigService()
    .setClientConfig(configToPayload(config))
    .then(response => {
      dispatch({
        type: ActionTypes.SET_CLIENT_CONFIG,
        payload: response.data,
      });
      setNotification(
        'Die Konfiguration wurde erfolgreich geändert und an DPlus übertragen. Bitte jetzt neu anmelden...',
        []
      );
    });
};

const configToPayload = (config: ConfigModel) => {
  const cpa: ConfigParam[] = [
    {
      key: ConfigEnum.IS_MAUTRECHNER,
      value: booleanToString(config.isMautrechner),
    },
    {
      key: ConfigEnum.IS_REGISTRIERUNG,
      value: booleanToString(config.isRegistrierung),
    },
    {
      key: ConfigEnum.IS_PREISERMITTLUNG,
      value: booleanToString(config.isPreisermittlung),
    },
    {
      key: ConfigEnum.IS_CUSTOMSTYLEBUTTONS,
      value: booleanToString(config.isCustomstylebuttons),
    },
    {
      key: ConfigEnum.IS_BEX_PREMIUM,
      value: booleanToString(config.isBexPremium),
    },
    {
      key: ConfigEnum.IS_DISABLE_UHRZEITFELDER,
      value: booleanToString(!config.isDisableUhrzeitfelder),
    },
    {
      key: ConfigEnum.IS_TAUSCHGERAETE,
      value: booleanToString(config.isTauschgeraete),
    },
    {
      key: ConfigEnum.IS_ZUSAETZLICHELADEMITTEL,
      value: booleanToString(config.isZusaetzlicheLademittel),
    },
    {
      key: ConfigEnum.IS_LAENGE_PFLICHTFELD,
      value: booleanToString(config.isLaengePflichtfeld),
    },
    {
      key: ConfigEnum.IS_BREITE_PFLICHTFELD,
      value: booleanToString(config.isBreitePflichtfeld),
    },
    {
      key: ConfigEnum.IS_HOEHE_PFLICHTFELD,
      value: booleanToString(config.isHoehePflichtfeld),
    },
    {
      key: ConfigEnum.IS_VERKEHRSART_PFLICHTFELD,
      value: booleanToString(config.isVerkehrsartPflichtfeld),
    },
    {
      key: ConfigEnum.IS_STELLPLAETZE_BERECHNEN,
      value: booleanToString(config.isStellplaetzeBerechnen),
    },
    {
      key: ConfigEnum.IS_LADEMETER_BERECHNEN,
      value: booleanToString(config.isLademeterBerechnen),
    },
    {
      key: ConfigEnum.IS_BELADEDATUMVORBELEGEN,
      value: booleanToString(config.isBeladedatumVorbelegen),
    },
    {
      key: ConfigEnum.IS_ENTLADEDATUMVORBELEGEN,
      value: booleanToString(config.isEntladedatumVorbelegen),
    },
    {
      key: ConfigEnum.IS_USER_CAN_EDIT_EDIT_IMMEDIATELY,
      value: booleanToString(config.isUserCanEditImmediately),
    },

    {
      key: ConfigEnum.IS_SERVICES_INTERN_SENDUNGEN,
      value: booleanToString(config.isServicesInternSendungen),
    },
    {
      key: ConfigEnum.CLIENT_KUNDE,
      value: config.clientKunde,
    },
    {
      key: ConfigEnum.CUSTOM_SERVICES,
      value: config.customServices,
    },
    {
      key: ConfigEnum.AUFTRAGSRESEARCHTABLECONFIG,
      value: config.auftragsresearchtableconfig,
    },
    {
      key: ConfigEnum.IS_ADRESSE_TELEFON_EDIT,
      value: booleanToString(config.isAdresseTelefonEdit),
    },
    {
      key: ConfigEnum.IS_ADRESSE_KONTAKT_EDIT,
      value: booleanToString(config.isAdresseKontaktEdit),
    },
    {
      key: ConfigEnum.IS_ADRESSE_EINMALADRESSE_EDIT,
      value: booleanToString(config.isAdresseEinmaladresseEdit),
    },
    {
      key: ConfigEnum.IS_ADRESSE_UNSICHTBAR_EDIT,
      value: booleanToString(config.isAdresseUnsichtbarEdit),
    },
    {
      key: ConfigEnum.IS_DOKUMENTENVERWEISE,
      value: booleanToString(config.dokumentenverweise),
    },
    // track and trace
    {
      key: ConfigEnum.TT_INHALT,
      value: booleanToString(config.ttInhalt),
    },
    {
      key: ConfigEnum.TT_EMPFAENGER_FREMDNUMMER,
      value: booleanToString(config.ttEmpfaengerFremdnummer),
    },
    {
      key: ConfigEnum.TT_EMPFAENGER_MATCHCODE,
      value: booleanToString(config.ttEmpfaengerMatchcode),
    },
    {
      key: ConfigEnum.TT_EMPFAENGER_STRASSE,
      value: booleanToString(config.ttEmpfaengerStrasse),
    },
    {
      key: ConfigEnum.TT_VERSENDER_FREMDNUMMER,
      value: booleanToString(config.ttVersenderFremdnummer),
    },
    {
      key: ConfigEnum.TT_VERSENDER_MATCHCODE,
      value: booleanToString(config.ttVersenderMatchcode),
    },
    {
      key: ConfigEnum.TT_VERSENDER_NAME,
      value: booleanToString(config.ttVersenderName),
    },
    {
      key: ConfigEnum.TT_VERSENDER_ORT,
      value: booleanToString(config.ttVersenderOrt),
    },
    {
      key: ConfigEnum.TT_VERSENDER_STRASSE,
      value: booleanToString(config.ttVersenderStrasse),
    },
    {
      key: ConfigEnum.TT_VERSENDER_FREMDNUMMER_LABEL,
      value: config.ttVersenderFremdnummerLabel ?? undefined,
    },
    {
      key: ConfigEnum.TT_VERSENDER_BLOCK_LABEL,
      value: config.ttVersenderBlockLabel ?? undefined,
    },
    {
      key: ConfigEnum.TT_IS_SHOW_TT_MAILADRESS,
      value: booleanToString(config.isShowTTMailAdress),
    },
    {
      key: ConfigEnum.TT_IS_SHOW_EMPF_RECHNUNG,
      value: booleanToString(config.isShowEmpfRechnung),
    },
    {
      key: ConfigEnum.IS_SHOW_ALLGEMEIN_KLASSIFIZIERUNG, //neuer config_param
      value: booleanToString(config.isShowKlassifizierung),
    },

    {
      key: ConfigEnum.IS_DENY_ORDER_EDIT, //neuer config_param
      value: booleanToString(config.denyOrderEdit),
    },
    {
      key: ConfigEnum.CLIENT_INFOBOX, //neuer config_param
      value: config.clientInfobox ?? undefined,
    },
    {
      key: ConfigEnum.IS_NO_ADR_VERPACKUNGEN,
      value: booleanToString(config.isNoADRVerpackungen),
    },
    {
      key: ConfigEnum.IS_NO_ADR_LADEMITTEL,
      value: booleanToString(config.isNoADRLademittel),
    },
    {
      key: ConfigEnum.IS_DENY_ZUSTELLDATUM,
      value: booleanToString(config.isDenyZustelldatum),
    },
    {
      key: ConfigEnum.TERMINART_FIXTERMIN,
      value: config.terminArtFixTermin ?? '',
    },
    {
      key: ConfigEnum.SAVE_KONTAKTDATEN,
      value: booleanToString(config.saveKontaktdaten),
    },
    {
      key: ConfigEnum.IS_ABSENDER_EDIT_DENY,
      value: booleanToString(config.isAbsenderEditDeny),
    },
    {
      key: ConfigEnum.IS_SHOW_ABSENDER_NEUTRAL,
      value: booleanToString(config.isShowAbsenderNeutral),
    },
    {
      key: ConfigEnum.IS_ABHOLDATUM_PFLICHT,
      value: booleanToString(config.isAbholDatumPflicht),
    },
    {
      key: ConfigEnum.IS_ZUSTELLDATUM_PFLICHT,
      value: booleanToString(config.isZustellDatumPflicht),
    },
    {
      key: ConfigEnum.TT_ABSENDER_SWITCH_TO_NEUTRAL,
      value: booleanToString(config.isTTSwitchAbsenderToNeutral),
    },
    {
      key: ConfigEnum.DEFAULT_WAEHRUNG,
      value: config.defaultWaehrung,
    },
    {
      key: ConfigEnum.DIRECTLY_BACK_2LIST,
      value: booleanToString(config.directly_back_2list),
    },
  ];
  return cpa;
};

export const setConfigParamField =
  (value: string | boolean, fieldName: string) =>
  (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_CONFIG_PARAM_FIELD,
      payload: { value: value, fieldName: fieldName },
    });
  };
